import React from 'react';
import './Modal.scss';
import {connect} from 'react-redux';
import RoundRectangleModal from '../RoundRectangleModal/RoundRectangleModal';
import EButton from '../Ebutton/Ebutton';

const Modal = ({
    showModal,
    handleClose,
    handleClick,
    modalText,
}) => {
    const modalBody = () => {
        return (
            <div className='modal-body-container'>
                <div className='modal-subtitle'>
                    {modalText}
                </div>
                <div className='btn-container modal-btn-container'>
                    <EButton
                        classNameButton='modal-btn'
                        text='ACEPTAR'
                        style={{width: '100%'}}
                        onClick={handleClick}
                    />
                </div>
            </div>
        );
    };

    return (
        <RoundRectangleModal
            isOpen={showModal}
            handleOnClose={handleClose}
            showCloseIcon={true}
            body={modalBody()}
        />
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
